import { Confirm } from '@core/ui';
import { Trans, useTranslation } from 'react-i18next';
import { LinkWarningModalProps } from './types';

// Mounted only while a link is pending, so a chat with hundreds of messages carries no idle dialogs.
// Confirm runs onClose and onConfirm synchronously inside the click, which keeps window.open inside
// the user gesture (popup blockers) — do not make the open asynchronous.
export const LinkWarningModal = ({ url, onClose }: LinkWarningModalProps) => {
    const { t } = useTranslation();

    const openLink = () => {
        const opened = window.open(url.href, '_blank', 'noopener,noreferrer');
        if (opened) opened.opener = null;
    };

    return (
        <Confirm
            open
            onClose={onClose}
            onConfirm={openLink}
            title={t('Chat.LinkWarning.Title')}
            closeText={t('Generic.Button.Cancel')}
            confirmText={t('Chat.LinkWarning.Continue')}
            closeTestId="chat-link-warning-cancel"
            confirmTestId="chat-link-warning-continue"
        >
            <p>
                {/* Punycode hostname from the parser, never the sender's display text: a homograph shows as xn--… */}
                <Trans i18nKey="Chat.LinkWarning.Body" values={{ hostname: url.hostname }} components={{ strong: <strong /> }} />
            </p>
        </Confirm>
    );
};
